module.exports = __webpack_public_path__ + "img/award_2026.013c5da2.jpg";